import { css } from '@emotion/react';

export const wrapper = css`
  width: 100%;
  height: 100%;
  max-width: 1304px;
  margin: 0 auto;
  padding: 0 calc(var(--unit) * 5);
`;
